<template>
    <SimpleModal
        v-if="showModal"
        :show-close-button="false"
        @close="$emit('close')"
    >
        <template v-slot:header>
            <h2>
                Move chat<br>
                <small v-if="currentAgent">{{ currentAgent.fullname }}</small>
            </h2>
        </template>
        <template v-slot:body>
            <div class="form-group">
                <select
                    class="form-control"
                    :class="{'has-error': errors.first('move_to_agent') }"
                    name="move_to_agent"
                    v-model="formData.move_to_agent"
                >
                    <option value="" selected disabled>Please select an agent</option>
                    <option
                        v-for="agent in filteredUserAgentsExceptCurrentAgent"
                        :key="agent.uuid"
                        :value="agent.uuid"
                    >
                        {{ agent.fullname }}
                    </option>
                </select>
                <div class="form-error">{{ errors.first('move_to_agent') }}</div>
            </div>
        </template>
        <template v-slot:footer>
            <div class="d-flex justify-content-between">
                <button
                    type="button"
                    class="btn btn--transparent-outlined"
                    :disabled="isLoading"
                    @click.prevent="onMove"
                >
                    Move
                </button>
                <button
                    type="button"
                    class="btn btn--secondary"
                    :disabled="isLoading"
                    @click.prevent="onCancel"
                >
                    Cancel
                </button>
            </div>
        </template>
    </SimpleModal>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import SimpleModal from '@components/partials/modal/SimpleModal.vue';

export default {
    $_veeValidate: {
        validator: 'new', // give me my own validator scope.
    },
    components: {
        SimpleModal,
    },
    props: {
        showModal: {
            type: Boolean,
            required: true,
        },
        agent: {
            type: Object,
            required: false,
        },
        conversation: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            formData: {
                move_to_agent: '',
            },
            isLoading: false,
        };
    },
    computed: {
        ...mapState('user', ['filteredUserAgents', 'user']),
        filteredUserAgentsExceptCurrentAgent() {
            if (this.agent) {
                return this.filteredUserAgents.filter((agent) => agent.uuid !== this.agent.identity);
            }
            return this.filteredUserAgents;
        },
        currentAgent() {
            if (this.agent) {
                return this.filteredUserAgents.find((agent) => agent.uuid === this.agent.identity);
            }
            return null;
        },
    },
    watch: {
        showModal(isOpened) {
            if (!isOpened) {
                this.formData = {
                    move_to_agent: '',
                };
            }
            this.$validator.reset();
        },
    },
    methods: {
        ...mapActions('user', ['moveChat']),
        onMove() {
            this.$validator.validate().then(async (valid) => {
                if (valid) {
                    this.isLoading = true;
                    this.$emit('close');
                    await this.moveChat({ conversationSid: this.conversation.sid, move_from_agent: this.agent ? this.agent.identity : null, ...this.formData });
                    this.isLoading = false;
                    window.showToastSuccess('Chat moved.');
                }
            });
        },
        onCancel() {
            this.$emit('close');
        },
    },
};
</script>
